<div class="app-container">
  <page-header [icon]="'far-file'" [title]="'consents'">
    <ng-container class="header-button">
      <btn
        [icon]="'far-plus'"
        [label]="'consent.new'"
        [title]="'consent.new' | translate"
        [classes]="['btn-first', 'float-right']"
        [routerLink]="['/consent']"
        [dataCyAttribute]="'go-consent'"
      ></btn>
    </ng-container>
  </page-header>

  <section class="content">
    <app-filter-form
      [filters]="queryFilters()"
      [filtersForExport]="queryFilters()"
      [entity]="'consents'"
      (onSubmit)="queryConsents.refetch()"
      (onClearClick)="clearFilters()"
      [isFilterInvisible]="true"
      [totalItems]="totalItems()"
    >
      <form-row-input
        [model]="filters().name"
        (modelChange)="onNameFilterChange($event)"
        (keydown.enter)="queryConsents.refetch()"
        [label]="'consent.name'"
        [icon]="'far-file'"
        [dataCyAttribute]="'consent-name-filter'"
      ></form-row-input>
    </app-filter-form>

    <app-base-listing
      [listName]="'consents'"
      [query]="queryConsents"
      [columns]="listingColumns"
      [selectedColumns]="listingColumns"
      [sortProp]="sortProp"
      [sortDir]="sortDir"
    ></app-base-listing>
  </section>
</div>
